import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { psb } from '../_psb';

import auth from '../modules/auth/Reducer';

import users from '../modules/users/Reducer';
import artisans from '../modules/artisans/Reducer';
import suppliers from '../modules/suppliers/Reducer';
import customers from '../modules/customers/Reducer';

import artisanCategories from '../modules/artisanCategories/Reducer';
import supplierCategories from '../modules/supplierCategories/Reducer';

// Job Categories
import artisanJobCategories from '../modules/artisanJobCategories/Reducer';
import supplierJobCategories from '../modules/supplierJobCategories/Reducer';

import artisanProducts from '../modules/artisanProducts/Reducer';
import supplierProducts from '../modules/supplierProducts/Reducer';

import artisanTags from '../modules/artisanTags/Reducer';
import supplierTags from '../modules/supplierTags/Reducer';

// Jobs
import artisanJobs from '../modules/artisanJobs/Reducer';
import applicantJobs from '../modules/applicantJobs/Reducer';
import supplierJobs from '../modules/supplierJobs/Reducer';

import pendingCustomers from '../modules/customersModearion/customers/Reducer';
import pendingApplicants from '../modules/applicantsModearion/applicants/Reducer';
import pendingArtisans from '../modules/artisanModeration/artisans/Reducer';
import pendingSuppliers from '../modules/supplierModeration/suppliers/Reducer';

import pendingArtisanProducts from '../modules/artisanModeration/artisanProducts/Reducer';
import pendingSupplierProducts from '../modules/supplierModeration/supplierProducts/Reducer';

// Job Moderation
import pendingArtisanJobs from '../modules/artisanModeration/artisanJobs/Reducer';
import pendingSupplierJobs from '../modules/supplierModeration/supplierJobs/Reducer';

import supplierPrivateInquiries from '../modules/inquiries/suppliers/private/Reducer';
import supplierPublicInquiries from '../modules/inquiries/suppliers/public/Reducer';

import artisanPrivateInquiries from '../modules/inquiries/artisans/private/Reducer';
import artisanPublicInquiries from '../modules/inquiries/artisans/public/Reducer';

import pendingArtisansPublicInquiry from '../modules/artisanModeration/publicInquiry/Reducer';
import pendingArtisansPrivateInquiry from '../modules/artisanModeration/privateInquiry/Reducer';

import pendingSuppliersPrivateInquiry from '../modules/supplierModeration/privateInquiry/Reducer';
import pendingSuppliersPublicInquiry from '../modules/supplierModeration/publicInquiry/Reducer';

import usersReports from '../modules/reports/users/Reducer';
import artisansReports from '../modules/reports/artisans/Reducer';
import suppliersReports from '../modules/reports/suppliers/Reducer';

import artisansTagsReports from '../modules/reports/artisansTags/Reducer';
import artisansCategoriesReports from '../modules/reports/artisansCategories/Reducer';

import suppliersTagsReports from '../modules/reports/suppliersTags/Reducer';
import suppliersCategoriesReports from '../modules/reports/suppliersCategories/Reducer';

import artisanFollowerList from '../modules/FollowersList/Artisan/Reducer';
import supplierFollowerList from '../modules/FollowersList/Supplier/Reducer';

import myArtisanProductsList from '../modules/myProductList/Artisan/Reducer';
import mySupplierProductsList from '../modules/myProductList/Supplier/Reducer';

import myArtisanPrivateInquiries from '../modules/myInquiries/Artisan/Private/Reducer';
import mySupplierPrivateInquiries from '../modules/myInquiries/Supplier/Private/Reducer';

import myArtisanPublicInquiries from '../modules/myInquiries/Artisan/Public/Reducer';
import mySupplierPublicInquiries from '../modules/myInquiries/Supplier/Public/Reducer';

import customerArtisanFollowingList from '../modules/customerFollowingArtisanList/Reducer';
import customerSupplierFollowingList from '../modules/customerFollowingSupplierList/Reducer';

import customerFavArtisanProducts from '../modules/customerFavArtisanProducts/Reducer';
import customerFavSupplierProducts from '../modules/customerFavSupplierProducts/Reducer';
import CustomerPrivateArtisanInquiries from '../modules/inquiries/artisans/private/Reducer';
import CustomerPrivateSupplierInquiries from '../modules/inquiries/suppliers/private/Reducer';

import customerPublicSupplierInquiries from '../modules/inquiries/suppliers/public/Reducer';
import applicant from '../modules/applicants/Reducer';
import customerPublicArtisanInquiries from '../modules/inquiries/artisans/public/Reducer';
import customerLimit from '../modules/customerLimits/Reducer';
import trainingCenterReducer from '../modules/trainingCenter/Reducer';
import notifications from '../modules/notifications/Reducer';
import modals from '../modules/Modals/Reducer';
import stats from '../modules/statistics/Reducer';

import PendingArtisanProposals from '../modules/artisanModeration/privateProposals/Reducer';
import PendingSupplierProposals from '../modules/supplierModeration/privateProposals/Reducer';

import PendingPublicArtisanProposals from '../modules/artisanModeration/publicProposals/Reducer';
import PendingPublicSupplierProposals from '../modules/supplierModeration/publicProposals/Reducer';

import { reducer as i18n } from '../modules/i18n/index';
import globalFail from '../modules/globalFail/Reducer';

// Artisan Jobs

// import artisanJobs from '../modules/jobs/Artisan/Reducer';
// import supplierJobs from '../modules/jobs/Supplier/Reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    users,
    artisans,
    suppliers,
    customers,
    artisanCategories,
    supplierCategories,

    // Job Categories
    artisanJobCategories,
    supplierJobCategories,

    artisanProducts,
    supplierProducts,

    artisanTags,
    supplierTags,

    artisanJobs,
    supplierJobs,
    applicantJobs,

    pendingCustomers,
    pendingArtisans,
    pendingSuppliers,
    pendingApplicants,

    pendingArtisanProducts,
    pendingSupplierProducts,

    // Moderation Jobs
    pendingArtisanJobs,
    pendingSupplierJobs,

    artisanPublicInquiries,
    artisanPrivateInquiries,

    supplierPublicInquiries,
    supplierPrivateInquiries,

    pendingArtisansPublicInquiry,
    pendingArtisansPrivateInquiry,

    pendingSuppliersPrivateInquiry,
    pendingSuppliersPublicInquiry,

    customerPublicSupplierInquiries,
    customerPublicArtisanInquiries,

    usersReports,
    artisansReports,
    suppliersReports,

    artisansCategoriesReports,
    artisansTagsReports,

    // artisanJobs,
    // supplierJobs,

    PendingArtisanProposals,
    PendingSupplierProposals,

    PendingPublicArtisanProposals,
    PendingPublicSupplierProposals,

    suppliersCategoriesReports,
    suppliersTagsReports,

    artisanFollowerList,
    supplierFollowerList,

    myArtisanProductsList,
    mySupplierProductsList,

    myArtisanPrivateInquiries,
    mySupplierPrivateInquiries,

    myArtisanPublicInquiries,
    mySupplierPublicInquiries,

    customerArtisanFollowingList,
    customerSupplierFollowingList,

    customerFavArtisanProducts,
    customerFavSupplierProducts,
    customerLimit,
    CustomerPrivateArtisanInquiries,
    CustomerPrivateSupplierInquiries,
    trainingCenterReducer,
    applicant,
    modals,
    globalFail,
    i18n,
    notifications,
    stats,

    builder: psb.builder.reducer
  });
